import type { TimesheetFilters } from "@/pages/stundennachweise/useTimesheetFilters";

const BASE_SUBTITLE =
  "Filtere nach Jahr, Kunde, Ordner, S-Ordner oder Abrechnung, um deine Stundennachweise schnell zu finden.";

export function buildTimesheetFilterHeading(
  filters: TimesheetFilters,
  ordnerBeschreibung?: string,
): string {
  const suche = (filters.q || "").trim();
  if (suche) {
    return `Suchergebnisse für „${suche}"`;
  }

  let text = "Alle Stundennachweise";

  if (filters.jahr === "S") {
    if (filters.sordner) {
      const besch = ordnerBeschreibung ? ` – ${ordnerBeschreibung}` : "";
      text = `${filters.sordner}${besch}`;
    } else {
      text = "S-Ordner – alle Jahre";
    }
  } else if (typeof filters.jahr === "number") {
    text = `Stundennachweise ${filters.jahr}`;
    if (filters.ordner) {
      const besch = ordnerBeschreibung ? ` – ${ordnerBeschreibung}` : "";
      text = `Ordner: ${filters.ordner}${besch}`;
    } else if (filters.kunde) {
      text = `Kunde: ${filters.kunde}`;
    }
  }

  return text;
}

export function buildTimesheetFilterSubtitle(filters: TimesheetFilters): string {
  const suche = (filters.q || "").trim();
  if (suche) return `Suchergebnisse für „${suche}"`;
  return BASE_SUBTITLE;
}
